import React, { ReactElement, memo } from 'react';
import { Button, Row, Cell, Grid, Paragraph } from '@dexma/ui-components';
import i18n from 'asset/translation';
import gtmIds from 'adapter/in/dashboards/config/gtm';
import { StyledDeleteWidgetdModal } from 'adapter/in/dashboards/pages/Widget/DeleteWidgetModal/style';
import ServerErrorAlert from 'adapter/in/dashboards/components/ServerErrorAlert';

const gtm = gtmIds.widget.deleteModal;

export type DeleteWidgetModalProps = {
    error: boolean;
    success: boolean;
    isLoading: boolean;
    showModal: boolean;
    setShowModal: (show: boolean) => void;
    onDelete: () => void;
};

const DeleteWidgetModal = memo(
    (props: DeleteWidgetModalProps): ReactElement => {
        const { onDelete, showModal, setShowModal, error, success, isLoading } = props;

        let dataTestId = 'delete-button';
        if (success) dataTestId = 'success';
        if (isLoading) dataTestId = 'loading';

        const handleDeleteModal = () => onDelete();
        const handleCloseModal = () => setShowModal(false);
        return (
            <StyledDeleteWidgetdModal width={450} visible={showModal} onCancel={handleCloseModal} title={i18n.t('widgets.actionDelete')}>
                <Grid fluid className='no-padding-grid' data-testid='delete-widget-modal'>
                    <Row>
                        {error && (
                            <Cell>
                                <ServerErrorAlert tryAgain={() => onDelete()} dataId={`$${gtm.actions.tryAgain}`} />
                            </Cell>
                        )}
                    </Row>
                    <Row>
                        <Cell>
                            <Paragraph data-testid='delete-message' margin='0 40px 0 0'>
                                {i18n.t('widgets.delete.warningMsg')}
                            </Paragraph>
                        </Cell>
                    </Row>
                    <div className='buttons'>
                        <Button
                            variant='destructive'
                            text={i18n.t('widgets.delete.yes')}
                            data-testid={dataTestId}
                            isLoading={isLoading}
                            iconBefore={success ? 'check' : ''}
                            onClick={isLoading ? undefined : handleDeleteModal}
                            dataId={gtm.actions.delete}
                        />
                        <Button
                            className='cancel'
                            variant='secondary'
                            text={i18n.t('widgets.delete.no')}
                            type='button'
                            data-testid='cancel-button'
                            onClick={handleCloseModal}
                            dataId={gtm.actions.cancel}
                        />
                    </div>
                </Grid>
            </StyledDeleteWidgetdModal>
        );
    }
);

export default DeleteWidgetModal;
